import * as React from 'react';
import * as _ from 'lodash';
import { IDonorStatus, IDashRegistrationLog, IDonorRegistration } from '@nkr/models/index';
import { Col, Row } from 'react-bootstrap';
import DashStatusForm from './status-form';
import { IDashRemoteStatus } from '@nkr/models/donor-status-by-center';
import { IDashWorkFlowStatusRequest } from '@nkr/models/dash-workflow-status-request';

interface IProps {
    data: IDonorRegistration,
    statusList: IDonorStatus[],
    remoteStatusList: IDashRemoteStatus[],
    container: any,
    isMobile: boolean,
    disabled: boolean,
    validation: {
        centerWorkFlowIdValid: boolean,
        centerNextFollowupDateValid: boolean
    },
    ruleOutReasons?: Array<{ id: number; description: string }>,
    onDataChange: (field: string, value: any) => void,
    onUpdate: ( request : IDashWorkFlowStatusRequest ) => void,
    onSaveCenterCard?: () => void | Promise<void>,
    onSaveNetworkCard?: () => void | Promise<void>,
    onRuleOut?: (donorId: number, reasonId: number, allowReRegistration: boolean, useNkrAssistance: boolean, coordinatorName?: string, phoneNumber?: string, medicalReasonCategory?: number, medicalReasonNotes?: string) => void
}

interface IState {
    addEdit: {
        show: boolean,
        data: IDashRegistrationLog
    },
    delete: {
        show: boolean,
        data: IDashRegistrationLog
    },
    requiresFollowUp: boolean
}

class DonorDetails extends React.Component<IProps, IState> {
    readonly state: IState = {
        addEdit: {
            show: false,
            data: null
        },
        delete: {
            show: false,
            data: null
        },
        requiresFollowUp: false
    }

    componentDidMount() {
        const selectedItem = this.props.statusList.find(
            item => item.id == this.props.data.centerWorkflowId
        );

        if (selectedItem) {
            this.setState({
                requiresFollowUp: selectedItem.requiresFollowUp
            });
        }
    }

    render = () => {
        return (
            <>
                <div>
                    <Row>
                        <Col xs={12}>
                            <h4 className='text-center'>Living Donor Details</h4>
                            <div>
                                <Row>
                                    <Col xs={12}>
                                        <DashStatusForm
                                            data={this.props.data}
                                            statusList={this.props.statusList}
                                            remoteStatusList={this.props.remoteStatusList}
                                            onDataChange={this.props.onDataChange}
                                            onUpdate={this.props.onUpdate}
                                            onSaveCenterCard={this.props.onSaveCenterCard}
                                            onSaveNetworkCard={this.props.onSaveNetworkCard}
                                            useWideFormat={true}
                                            ruleOutReasons={this.props.ruleOutReasons}
                                            onRuleOut={this.props.onRuleOut}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

export default DonorDetails;
